<template>
  <div>
    <x-grid :id="'formList'"
            :rowId="rowId"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            ref="grid"
            :editable="true"
            :edit-rules="editRules"
            :treeConfig="treeConfig"
            :ajaxConfig="ajaxConfig"
            :cellDbClick="cellDbClick"
            @toolbar-addData="addRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="addRow">
          <a-icon type="diff"/>
          新增
        </vxe-button>
        <vxe-button @click="refresh">
          <a-icon type="redo"/>
          刷新
        </vxe-button>
      </template>

      <template v-slot:operate="{row}">
        <vxe-button style="margin-right: 10px" size="mini" status="primary" @click="updateRow(row)">编辑</vxe-button>
        <btn-confirm
            title="确定要删除吗?"
            @confirm="delRow(row)"
        >
          <vxe-button size="mini">删除</vxe-button>
        </btn-confirm>

      </template>

    </x-grid>


    <a-modal
        title="新增节点"
        centered
        :closable="false"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="800"
    >
      <menuManageDetail
          :rowId="editRowId"
          v-if="editModalVisible"
          ref="detailForm"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)">
      </menuManageDetail>
    </a-modal>

  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridTree'
import {GridTreeMinix} from '@/utils/GridTreeMixin'
import {
  formatter as fmt
} from "@/utils/ebase-formatter"

console.info(fmt);//防止未用到报未定义错误 用到了可删除
import api from '@/services/api';

const fac = XGrid.factory;


//私有化组件
import menuManageDetail from "@/pages/web/comm/menuManage/menuManageDetail";

//主键
const rowId = 'menuId';

const delUrl = api.comm.MENU;
const url = api.comm.MENU;

//查询表格
const ajaxConfig = fac.makeAjaxConfig(url, rowId);
const treeConfig = fac.makeTreeConfig();

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn({
    field: "name",
    title: "菜单名称",
    width: 200,
    treeNode: true,
  }),
  fac.makeColumn("url", "url", 200),
  fac.makeColumn("orderNum", "排序号", 100),
  fac.makeColumn("type", "类型", 100, 'center', true, function (res) {
    let type = res.cellValue;
    if (type === 0) {
      return '目录'
    } else if (type === 1) {
      return '菜单'
    } else if (type === 2) {
      return '按钮'
    }
  }),
  fac.makeColumn({
    title: "操作",
    width: 260,
    slots: {
      default: 'default'
    },
  }),
]

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);

export default {
  mixins: [GridTreeMinix],
  components: {
    menuManageDetail
  },
  data() {
    return {
      url,
      rowId,
      editRules,
      ajaxConfig,
      treeConfig,
      delUrl,
      toolbarConfig,
      columns
    }
  },
  // authorize: {
  //   addRow: 'ADD',
  //   updateRow:'UPDATE',
  //   delRow:'DELETE'
  // },
  methods: {}
}
</script>

<style scoped>
</style>